/**
 * Created by laugh on 7/15/2018.
 */

export default function (state = [], action) {

    switch (action.type) {
        case 'SET_FILMS':
            return action;
        default:
            return state
    }

}


// WEBPACK FOOTER //
// ./src/reducers/all-films.js